import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate(['SAVE_STATE']);
